import { useMemo } from "react";
import { t } from "@/i18n-js/instance";
import { EMAIL_REGEX } from "@/react/components/OnboardingPage/helpers/constants";
import type { FieldElement as FieldElementType } from "@/react/types/Element";

interface FieldRules {
  minLength?: {
    value: number;
    message: string;
  };
  pattern?: {
    value: RegExp;
    message: string;
  };
  required?: string;
}

export const useFieldElementRules = (element: FieldElementType): FieldRules =>
  useMemo(() => {
    const rules: FieldRules = {};

    if (element.attributes.field_type === "contact_email") {
      rules.pattern = {
        value: EMAIL_REGEX,
        message: t("settings.forms.errors.valid_email"),
      };
      if (element.attributes.required) {
        rules.required = t("settings.forms.errors.required_email");
      }
    } else if (element.attributes.field_type === "contact_name") {
      rules.minLength = {
        value: 2,
        message: t("settings.forms.errors.min_length_2"),
      };
    }

    if (element.attributes.required) {
      rules.required = t("settings.forms.errors.required", {
        field_name: element.attributes.label.toLowerCase(),
      });
    }
    return rules;
  }, [element]);
